// Unpublished Work © 2022-2025 Deere & Company.

import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {Redirect, useHistory} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {useOktaAuth} from '@okta/okta-react';
import {SET_CONFIGURATION, SET_USER_DATA} from '../../../action-list';
import {useIsJdfFlow} from '../../../services/jdf-services/jdf-hepler';
import {CustomerRoutes} from '../../../literals/customer-routes';
const SALES_CENTER_APP_NAME = 'Sales Center';

// eslint-disable-next-line max-statements
export const AccessCheck = (props) => {
    const {
        authState, oktaAuth
    } = useOktaAuth();

    const dispatch = useDispatch();

    const isCSC2User = useSelector((state) => state.user.isCSC2User);
    const impersonateUserId = useSelector((state) => state.user.impersonateUserId);
    const parentAppName = useSelector((state) => state.configuration.parentAppName);
    const [userId, setUserId] = React.useState(null);
    const routeRequested = useSelector((state) => state.configuration.routing?.view);
    const configuration = useSelector((state) => state.configuration);
    const isJdfFlow = useIsJdfFlow();
    const history = useHistory();

    React.useEffect(() => {
        if (authState.isAuthenticated) {
            // eslint-disable-next-line promise/catch-or-return
            oktaAuth.token.getUserInfo().then((user) => {
                setUserId(!impersonateUserId ? user.userID : impersonateUserId);
                dispatch({
                    type: SET_USER_DATA,
                    user: {
                        loggedInUserId: user.userID
                    }
                });
            });
        } else {
            setUserId(impersonateUserId);
        }
    }, [authState, oktaAuth, impersonateUserId]);
    const routeMap = {
        'EDIT_CUSTOMER': CustomerRoutes.EDIT_JDF_CUSTOMER,
        'ADD_CUSTOMER': CustomerRoutes.ADD_JDF_CUSTOMER
    };
    const updateConfigurationAndRedirect = (route) => {
        dispatch({
            configuration: {
                routing: {
                    ...configuration.routing,
                    view: route === 'EDIT_CUSTOMER' ? 'EDIT_JDF_CUSTOMER' : 'ADD_JDF_CUSTOMER'
                }
            },
            type: SET_CONFIGURATION
        });
        history.push(routeMap[route]);
    };

    React.useEffect(() => {
        if (isJdfFlow && routeMap[routeRequested]) {
            updateConfigurationAndRedirect(routeRequested);
        }
    }, [routeRequested, isJdfFlow, updateConfigurationAndRedirect]);

    const renderNoAccess = () => userId ? <Redirect
        to={{
            pathname: '/no-access',
            state: {
                message: <FormattedMessage
                    id={'messages.USER_CANNOT_USE_CSC'}
                    values={{
                        userId
                    }}
                />
            }
        }}
    /> : null;

    const renderCSCRoutes = () => props.children;

    const checkCSC2User = () => isCSC2User ? renderCSCRoutes() : renderNoAccess();

    const isParentAppSalesCenter = () => parentAppName.startsWith(SALES_CENTER_APP_NAME);

    return isParentAppSalesCenter() ? renderCSCRoutes() : checkCSC2User();
};

AccessCheck.propTypes = {
    children: PropTypes.element.isRequired
};
